// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","container":"_1fB1PMkt-PubQQRlV1dB2Z","subHeader":"_2oHUhRrz5gBVdv73dtpsfX"};